export default "__VITE_ASSET__ec4b88a0__"